import React, { useState } from "react";
import { HiMenuAlt4, HiX } from 'react-icons/hi'; 
import { motion } from 'framer-motion'; 

// images is an object
import { images } from "../../constants";
import "./Navbar.scss";

const Navbar = () => {

  const [toggle, setToggle] = useState(false); 

  return (

    // Note : __ is a front-end naming method for creating clean CSS with BEM methodology
    <nav className="app__navbar">

      {/* Logo Image at navbar */}
      <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div>

      {/* Navbar at the top for Dektop view */}
      <ul className="app__navbar-links">
        {/* Iterating through the array and returning a list of items which are links 
        Note : We are using () instead of {} for the .map() function */}
        {["home", "about", "work", "skills", "contact"].map((item) => (
          // Giving each item in the array a unique key identifier
          // Styling the links using className
          <li className="app__flex p-text" key={`link-${item}`}>
            {/* This div is to create the dot effect above the links */}
            <div />
            {/* Making each item in the list a link */}
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      {/* Navbar/Menubar on the right side for mobile view */}
      <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)}/>

          {/* If toggle is true then we render our menu bar  */}
          { toggle && (
            <motion.div
              // Menu bar is going to take up 300 px
              whileInView={{x: [300,0] }}
              transition={{ duration: 0.85, ease: 'easeOut'}}
            > 
              {/* Close Icon */}
              <HiX onClick={() => setToggle(false)} />

              {/* Links in menu bar */}
              <ul>
                {["home", "about", "work", "skills", "contact"].map((item) => (
                  <li key={item}>
                    {/* Closes the menu bar when a link is clicked */}
                    <a href={`#${item}`} onClick={() => setToggle(false)} >{item}</a>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
      </div>

    </nav>
  );
};

export default Navbar;